import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/service?${params}`);
  },
  getById(id) {
    return api.get(`/api/v1/service/${id}`);
  },
  update(id, data) {
    return api.put(`/api/v1/service/${id}`, data);
  },
  create(data) {
    return api.post(`/api/v1/service`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/service/${id}`);
  },
  addServiceToPos(data) {
    return api.post(`/api/v1/service/add`, data);
  },
  removeServiceFromPos(id) {
    return api.delete(`/api/v1/service/remove/${id}`);
  },
};
